// extracted by mini-css-extract-plugin
export default {"container":"Assistant_container__-RVzc","iframe":"Assistant_iframe__Txo9d"};